<div class="main">
    <div class="contant">
        <div class="left">
            <p>Why Choose Us</p>
            <h3>Why Our Platform Stands Out</h3>
            <p>Our platform is designed to provide a comprehensive, flexible, and high-quality learning experience 
                that sets you apart in the coaching industry.</p>
            <ul>
                <li><i class="fa-solid fa-star"></i>Flexible Scheduling</li>
                <li><i class="fa-solid fa-star"></i>Expert Instructors</li>
                <li><i class="fa-solid fa-star"></i>ICF-Certified & Industry-Recognized</li>
                <li><i class="fa-solid fa-star"></i>Hands-On Learning & Practical Application</li>
            </ul>
            <button class="common-button" routerLink="/program-page">Explore Packages</button>
        </div>
        <div class="right">
          <img src="../../../assets/certification-program.jpeg" alt="">
        </div>
    </div>
</div>